var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"724475c141a54028515d9c90416b2295e3c95d91"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kikushiru@inditidual"]={id:"724475c141a54028515d9c90416b2295e3c95d91"};
      